var dbConfig = {
    dbName: "IranAirTour",
    version: 1,
    objectStores: [
        {
            name: "errors",
            keyPath: "id",
            autoIncrement: true,
            indexes: [
                {
                    name: "dateIndex",
                    keyPath: "date",
                    unique: false,
                },
            ],
        },
    ],
};
export default dbConfig;
